/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DisplayBlockSmallIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DisplayBlockSmallIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 3H4L4 12H13V3ZM4 2C3.44772 2 3 2.44771 3 3V12C3 12.5523 3.44771 13 4 13H13C13.5523 13 14 12.5523 14 12V3C14 2.44772 13.5523 2 13 2H4Z"
            fill="currentColor"
          />
          <rect
            opacity="0.6"
            x="5"
            y="4"
            width="7"
            height="7"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DisplayBlockSmallIcon.tags = ['block', 'box', 'square', 'outline', 'frame'];

DisplayBlockSmallIcon.category = 'Layout';

DisplayBlockSmallIcon.iconSize = 16;
